import * as React from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { Globals } from "../../Globals";
import { HRQuestionId } from "../../messages";
import { HRQuestion } from "../../messages/HR";
import { HRQuestionWithStatus } from "../../models/HR";
import "./GenericAddressInput.css";
import { GenericInputHeader } from "./GenericInputHeader";


interface GenericAddressInputProps {
    hrAddressQuestionWithStatus: HRQuestionWithStatus<HRQuestion.AddressQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

interface GenericAddressInputState {
    currentVal: string;
}

export class GenericAddressInput extends React.Component<GenericAddressInputProps, GenericAddressInputState> {
    constructor(props: GenericAddressInputProps) {
        super(props);

        if (props.hrAddressQuestionWithStatus.question.answer === null) {
            // Check if we have to auto complete this
            const lastAddress = Globals.getAnswerByTemplateId(props.hrAddressQuestionWithStatus.question.textId);
            if (lastAddress !== null) {
                this.state = {
                    currentVal: lastAddress
                };
                props.onChange(lastAddress, props.hrAddressQuestionWithStatus.question.id);
                props.onBlur(props.hrAddressQuestionWithStatus.question.id);
            } else {
                this.state = {
                    currentVal: ""
                };
            }
        } else {
            this.state = {
                currentVal: props.hrAddressQuestionWithStatus.question.answer
            };
        }

        this.isValid = props.hrAddressQuestionWithStatus.question.answer !== null;
    }

    isValid: boolean;

    handleSelect = (address: string, placeId: any) => {
        this.isValid = true;
        if (placeId !== null && placeId !== undefined) {
            this.setState({ currentVal: address});
            this.props.onChange(address, this.props.hrAddressQuestionWithStatus.question.id);
            this.props.onBlur(this.props.hrAddressQuestionWithStatus.question.id);
        }
    }

    handleChange = (val: string) => {
        this.isValid = false;
        this.setState({ currentVal: val});
    }

    handleBlur = () => {
        if (!this.isValid) {
            if (this.state.currentVal === "") {
                this.props.onChange(null, this.props.hrAddressQuestionWithStatus.question.id);
            } else {
                this.props.onChange("", this.props.hrAddressQuestionWithStatus.question.id);
            }
            this.props.onBlur(this.props.hrAddressQuestionWithStatus.question.id);
        }
    }

    render() {
        const question = this.props.hrAddressQuestionWithStatus.question;
        const status = this.props.hrAddressQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <PlacesAutocomplete
                    onChange={this.handleChange}
                    onSelect={this.handleSelect}
                    value={this.state.currentVal}
                    highlightFirstSuggestion={true}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div>
                        <input
                            {...getInputProps({
                                placeholder: "Search Places ...",
                                onBlur: this.handleBlur,
                                className: "form-control",
                                autoComplete: true
                            })}
                        />
                        <div className="autocomplete-dropdown-container">
                        {loading && <div>Loading...</div>}
                        {suggestions.map(suggestion => {
                            const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                            // inline style for demonstration purpose
                            const style = suggestion.active
                            ? { backgroundColor: "#fafafa", cursor: "pointer" }
                            : { backgroundColor: "#ffffff", cursor: "pointer" };
                            return (
                                <div
                                    {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                    })}
                                    key={suggestion.id}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                            );
                        })}
                        </div>
                    </div>
                    )}
                </PlacesAutocomplete>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericAddressInput.tsx